<template>
  <template v-if="datas.settings.header.settings.pc_search === 'input' || !datas.settings.header.settings.pc_search">
    <n-input class="uppercase" :placeholder="$t('headers.search')" style="width: 206px" @input="reseachIpt">
      <template #prefix>
        <icon name="icon:resch" class="h-16px w-16px color-[--search-color] opacity-50" />
      </template>
    </n-input>
  </template>

  <div v-if="datas.settings.header.settings.pc_search === 'icon'" class="flex items-baseline">
    <icon name="icon:resch" class="w-20px cursor-pointer color-[--search-color]" @click="active = true" />
  </div>
  <teleport v-if="active" to="body">
    <div
      ref="drawerRef"
      v-auto-animate
      class="fixed left-0 top-0 z-9999 min-h-50 w-full flex-center flex-col gap-5 bg-white py-5"
    >
      <div class="h-25px max-w-1200px w-full flex-center flex-1 gap-5">
        <n-button text>
          <icon name="icon:resch" class="h-16px w-16px cursor-pointer opacity-50" @click="searchHandle" />
        </n-button>
        <n-input
          v-model:value="search"
          class="flex-1"
          :placeholder="$t('headers.search')"
          size="large"
          style="width: 300px"
          @input="debouncedFn"
        />
        <icon name="icon:close1" class="h-16px w-16px cursor-pointer color-[--search-color] opacity-50" @click="active = false" />
      </div>
      <div v-if="search" v-auto-animate class="max-w-1200px w-full flex-center flex-col gap-5">
        <nuxt-link :to="`/search?keyword=${search}`" class="group h-50px flex-center gap-5" @click="active = false">
          <span>{{ $t('headers.search') }} "{{ search }}"</span>
          <icon
            name="icon:arrow1"
            class="h-16px w-16px cursor-pointer color-[--search-color] transition-all sps-group-hover:transform-translate-x-5px"
          />
        </nuxt-link>

        <div v-if="searchSuggestList.length" v-auto-animate class="w-full flex-center flex-col gap-5">
          <div v-auto-animate class="w-full flex-col gap-2">
            <nuxt-link
              v-for="item in searchSuggestList"
              :key="item.id"
              :to="`/products/${item?.handle}`"
              class="w-full flex flex items-center justify-start gap-5 p-2 @hover:b-r-2 @hover:bg-gray-1"
              @click="active = false"
            >
              <sps-img class="h-50px w-50px" width="50" height="50" :src="item?.thumbs" />
              <span class="ellipsis-text w-full max-md:w-50px">
                {{ item?.title }}
              </span>
            </nuxt-link>
          </div>

          <n-button type="primary" class="min-w-100px text-center uppercase" @click="viewMoreHandle">
            <span>{{ $t('search.viewMore') }}</span>
          </n-button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts" setup>
import { onClickOutside, useDebounceFn } from '@vueuse/core'
import { searchSuggestAPI } from '~/services/api'

defineProps<{
  datas: any
}>()
const route = useRoute()
const drawerRef = ref()
const router = useRouter()
onClickOutside(drawerRef, () => {
  active.value = false
})
const reseachIpt = (event: any) => {
  if (route.path === '/search') {
    return router.replace(`/search?keyword=${event}`)
  }
  router.push(`/search?keyword=${event}`)
}

const active = ref(false)

const search = ref('')

// 搜索建议
const searchSuggestList = ref<any>([])

const loading = ref(false)
// 获取建议
const searchHandle = async () => {
  if (!search.value)
    return
  loading.value = true
  try {
    const { data }: any = await searchSuggestAPI(search.value)
    searchSuggestList.value = data?.data
  }
  catch (error) {
  }
  finally {
    loading.value = false
  }
}

const debouncedFn = useDebounceFn(searchHandle, 150)

const viewMoreHandle = () => {
  active.value = false
  router.replace(`/search?keyword=${search.value}`)
}

onUnmounted(() => {
  active.value = false
})

prefetchComponents('BlocksSearch')
</script>

<style lang="scss" scoped></style>
